import { cn } from "@/lib/utils";
import { ReactNode } from "react";

/**
 * XBRL 태그 불러오기 모달의 공통 골격 — Figma 5611:340832 / 5611:341478.
 * 헤더(46px) · 설명(40px) · 본문(flex) · 푸터(56px) 4단 구성을 두 단계가 공유한다.
 */

/** 헤더: px-24 / pt-20, 제목 18px SemiBold (46px). */
export const ForwardModalHeader = ({ title }: { title: string }) => (
  <div className="flex w-full shrink-0 items-center gap-2.5 px-6 pt-5">
    <h2 className="headline-1-semibold whitespace-nowrap text-label-normal">
      {title}
    </h2>
  </div>
);

/** 설명 줄: px-24 / pt-8 / pb-12, 14px Regular (40px). */
export const ForwardModalDescription = ({
  children,
}: {
  children: ReactNode;
}) => (
  <div className="flex w-full shrink-0 flex-col items-start px-6 pb-3 pt-2">
    <p className="label-1-normal-regular w-full text-label-alternative">
      {children}
    </p>
  </div>
);

/** 푸터: px-24 / pb-20, 버튼 오른쪽 정렬 (56px). */
export const ForwardModalFooter = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div
    className={cn(
      "flex w-full shrink-0 items-center justify-end gap-2 bg-static-white px-6 pb-5",
      className,
    )}
  >
    {children}
  </div>
);
